// Download IMQs
export const SEND_OUT_IMQS_FORM_ID = 'send-out-imqs-form';

// Submit RFQ
export const SUBMIT_RFQ_DEFAULT_CONTACT_SECTION_TEST_ID = 'default-contact-section';
export const SUBMIT_RFQ_ADDITIONAL_CONTACTS_SECTION_TEST_ID = 'additional-contacts-section';
export const SUBMIT_RFQ_ADD_CONTACT_BTN_TEST_ID = 'add-contact-btn';
export const SUBMIT_RFQ_NO_CONTACTS_MESSAGE_TEST_ID = 'no-contacts-message';
export const SUBMIT_RFQ_ADDITIONAL_CONTACT_BLOCK_TEST_ID = 'additional-contact-block';

// Pick Carriers
export const PICK_CARRIERS_TOGGLE_TEST_ID = 'pick-carriers-toggle';
export const PICK_CARRIERS_NO_DATA_PLACEHOLDER_TEST_ID = 'pick-carriers-no-data-placeholder';
export const PICK_CARRIERS_PRODUCT_LINE_CARD_TEST_ID = 'pick-carriers-product-line-card';
export const PICK_CARRIERS_PRODUCT_LINE_TABLE_TEST_ID = 'pick-carriers-product-line-table';
export const PICK_CARRIERS_CARRIER_ROW_LOGO_TEST_ID = 'pick-carriers-carrier-row-logo';
export const PICK_CARRIERS_CARRIER_ROW_LIST_TEST_ID = 'pick-carriers-carrier-row-list';
export const PICK_CARRIERS_CARRIER_ROW_ERROR_TEST_ID = 'pick-carriers-carrier-row-error';
export const PICK_CARRIERS_CARRIER_ROW_CONTACTS_BTN_TEST_ID = 'pick-carriers-carrier-contacts-btn';
export const PICK_CARRIERS_CARRIER_ROW_TEST_ID = 'pick-carriers-carrier-row';
export const PICK_CARRIERS_CARRIER_ROW_CONTACTS_MODAL_TEST_ID = 'pick-carriers-carrier-contacts-modal';
export const PICK_CARRIERS_CONTACTS_MODAL_PRIMARY_EMAIL_TEST_ID = 'pick-carriers-contacts-modal-primary-email';
export const PICK_CARRIERS_PRODUCT_LINE_SECTION_TITLE_TEST_ID = 'pick-carriers-product-line-section-title';
export const PICK_CARRIERS_PRODUCT_LINE_STATUS_TEST_ID = 'pick-carriers-product-line-status';
export const PICK_CARRIERS_CARRIER_CONTACTS_MODAL_ADD_CC_BTN_TEST_ID = 'pick-carriers-contacts-modal-add-cc-btn';
export const PICK_CARRIERS_CARRIER_CONTACTS_MODAL_REMOVE_CC_BTN_TEST_ID = 'pick-carriers-contacts-modal-remove-cc-btn';
export const PICK_CARRIERS_CARRIER_CONTACTS_MODAL_ERROR_TEST_ID = 'pick-carriers-contacts-modal-error';
